// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"1ec2e3af","359":"3d86deda","376":"89d5d94f","400":"fdea5de9"}[chunkId] + ".chunk.js";
};